import { Routes } from '@angular/router';

export const printAssetsRoutes: Routes = [
  {
    path: 'asset-templates',
    loadChildren: () => import('@rma/public/site/asset-templates'),
    data: {
      hideFooter: true,
      hideHeader: true,
    },
  },
  {
    path: 'market-report',
    loadChildren: () => import('@rma/public/reports/market-report'),
    data: {
      hideFooter: true,
      hideHeader: true,
    },
  },
];
